import { DependencyList, useEffect } from 'react';

export const useWindowResize = (cb: () => void, deps: DependencyList) => {
  useEffect(() => {
    window.addEventListener('resize', cb);
    return () => window.removeEventListener('resize', cb);
  }, deps);
};
